import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToTickets, type TicketsType } from "../model";

export const getCurrentTickets = async (
  ticketType: string,
  pageCount: number,
) => {
  const filters =
    ticketType !== "all"
      ? {
          ticket_types: {
            uid: {
              $in: [ticketType],
            },
          },
        }
      : {};

  const searchParams = {
    sort: ["sortOrder:asc"],
    pagination: {
      page: pageCount || 1,
      pageSize: 6,
    },
    filters: { ...filters },
    populate: {
      price: {
        populate: "*",
      },
      image: {
        populate: "*",
      },
      ticket_types: {
        populate: "*",
      },
    },
  };

  const ticketsData = strapiClient.collection("tickets");

  const tickets = await ticketsData.find({
    ...searchParams,
  });

  return rebuild(mapDtoToTickets(tickets)) as TicketsType;
};
